import { IconCancel } from 'components/icons'
import React, { useEffect } from 'react'
import { Modal, Tag } from 'antd'
import Button from 'components/button/Button'
import {
  IFilter,
  paymentMethodFilterVoucher,
  targetFilterVoucher,
  userFilterVoucher,
} from 'constants/tags'
import { PaymentMethodEnum, UserRoleEnum, VoucherTypeEnum } from 'generated/api'

interface ModalVoucherTagsProps {
  selectedTags: IFilter[]
  isOpen: boolean
  onCancel: (status: boolean) => void
  onSave: (filters: IFilter[]) => void
}

interface TagsSectionProps {
  title: string
  selectedTags: IFilter[]
  tags: IFilter[]
  onSelectTag: (selectTag: IFilter) => void
}

export default function ModalVoucherTags(props: ModalVoucherTagsProps) {
  const [selectedTags, setSelectedTags] = React.useState<IFilter[]>([])

  useEffect(() => {
    if (props.isOpen) {
      setSelectedTags(props.selectedTags)
    }
  }, [props.isOpen])

  const filterSelectedSet = new Set(selectedTags.map(item => item.value))

  const handleSelectTag = (selectedTag: {
    label: string
    value: VoucherTypeEnum | UserRoleEnum | PaymentMethodEnum
  }) => {
    if (filterSelectedSet.has(selectedTag.value)) {
      setSelectedTags(selectedTags.filter(item => item.value !== selectedTag.value))
    } else {
      setSelectedTags([...selectedTags, selectedTag])
    }
  }

  const handleResetFilter = () => {
    setSelectedTags([])
  }

  return (
    <Modal
      data-testid="modal_advanced_filter"
      centered
      onCancel={() => props.onCancel(false)}
      title="Filter"
      open={props.isOpen}
      footer={null}
      className="modal-advanced-filter-voucher"
      width={607}
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <div className="flex flex-col gap-6">
        <TagsSection
          title="Target Voucher"
          selectedTags={selectedTags}
          tags={targetFilterVoucher}
          onSelectTag={selected => handleSelectTag(selected)}
        />
        <TagsSection
          title="Pengguna"
          selectedTags={selectedTags}
          tags={userFilterVoucher}
          onSelectTag={selected => handleSelectTag(selected)}
        />
        <TagsSection
          title="Pembayaran"
          selectedTags={selectedTags}
          tags={paymentMethodFilterVoucher}
          onSelectTag={selected => handleSelectTag(selected)}
        />
      </div>
      <div className="flex flex-row gap-4 mt-6">
        <div className="xl:w-1/2 w-full">
          <Button
            data-testid="button-reset-tags"
            className="w-full text-[#3C5337] text-sm font-bold px-4 py-3 rounded-lg border hover:cursor-pointer"
            onClick={handleResetFilter}
          >
            Reset
          </Button>
        </div>
        <div className="xl:w-1/2 w-full">
          <Button
            data-testid="button-save-tags"
            className="w-full bg-[#3C5337] text-white text-sm font-bold px-4 py-3 rounded-lg hover:cursor-pointer"
            onClick={() => props.onSave(selectedTags)}
          >
            Simpan
          </Button>
        </div>
      </div>
    </Modal>
  )
}

function TagsSection(props: TagsSectionProps) {
  return (
    <div className="flex flex-col">
      <div className="text-[#323539] text-sm font-medium">{props.title}</div>
      <div className="flex flex-wrap gap-2 mt-3.5">
        {props.tags.map(tag => (
          <Tag
            key={tag.value}
            color={props.selectedTags.some(item => item.value === tag.value) ? '#F4F6F0' : '#fff'}
            className="select-none text-[#323539] border border-[#E5E5E7] p-2 rounded-lg hover:cursor-pointer"
            onClick={() => props.onSelectTag(tag)}
          >
            {tag.label}
          </Tag>
        ))}
      </div>
    </div>
  )
}
